// Import Package
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilState } from "recoil";

// Import Pages
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';
import AppCredential from '../AppCredential/AppCredential';
import { activeAutom } from "../../../../recoil-store/recoil-state";
import { RadioButtons } from "../../../FlowConfigurationInputs";

function SendMedia({ action, variables, setOpenVariable }) {
    const { t } = useTranslation();
    const label = 'CONTENT.CONFIGURATION-FORM.WHATSAPP.SEND-MEDIA.';
    const [outLabel, setOutLabel] = useState({ isOk: false, value: "" });
    const [automDetail, setAutomDetail] = useRecoilState(activeAutom);

    // const [automDetail, setAutomDetail] = useRecoilState(activeAutom);
    const [mediaType, setMediaType] = useState("image");

    useEffect(() => {
        if (action.fields.mediaType && action.fields.mediaType.value && action.fields.mediaType.value !== mediaType) {
            setMediaType(action.fields.mediaType.value);
        }
    }, [])

    useEffect(() => {
        if (action.fields?.label) {
            setOutLabel({ isOk: true, value: action.fields.label.value })
        }
    }, [action?.fields?.label?.value])

    const updateLabel = (id, items) => {
        let isDifferentLabel
        const innerUpdateLabel = (id, items) => {
            items.forEach(item => {
                if (item.id === id) {
                    item.fields = action.fields;
                    if (item.label !== action.fields.label.value && (item.label !== undefined || action.fields.label.value)) {
                        item.label = action.fields.label.value;
                        isDifferentLabel = true
                    }
                } else if (item.children) {
                    innerUpdateLabel(id, item.children);
                }
            });
        }
        innerUpdateLabel(id, items)
        return isDifferentLabel
    };

    const handleBlur = () => {
        let fields = action.fields;
        let items = JSON.parse(JSON.stringify(automDetail.items));
        action.fields = JSON.parse(JSON.stringify(fields));

        const isLabelsDifferent = updateLabel(action.id, items);
        if (!isLabelsDifferent) return
        setAutomDetail({ ...automDetail, items: JSON.parse(JSON.stringify(items)) });
    };

    const options = {
        mediaTypes: {
            data: [{
                value: 'image',
                label: label + 'IMAGE'
            }, {
                value: 'video',
                label: label + 'VIDEO'
            }],
            defaultValue: 'image'
        },
    }

    // const updateLabel = (id, items) => {
    //     items.forEach(item => {
    //         if (item.id === id) {
    //             item.fields = action.fields;
    //         } else if (item.children) {
    //             updateLabel(id, item.children);
    //         }
    //     });
    // };

    // const handleBlur = () => {
    //     let fields = action.fields;
    //     let items = JSON.parse(JSON.stringify(automDetail.items));
    //     action.fields = JSON.parse(JSON.stringify(fields));
    //     updateLabel(action.id, items);
    //     setAutomDetail({ ...automDetail, items: JSON.parse(JSON.stringify(items)) });
    // };


    return (
        <div>
            <AppCredential action={action} />
            <div className="form-element">
                {t(label + "LABEL")}
                <TextInput
                    action={action}
                    inputName="label"
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                    isRequired={false}
                    onBlur={handleBlur}
                    fieldType="string"
                    displayName={t(label + "LABEL")}
                    outNewValue={outLabel}
                    limit={40}
                />
            </div>
            {/* <div className="form-element">
                {t(label + "LABEL")}
                <TextInput
                    action={action}
                    inputName="label"
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                    isRequired={false}
                    onBlur={handleBlur}
                    fieldType="string"
                    displayName={t(label + "LABEL")}
                />
            </div> */}
            <div className="form-element">
                {t(label + 'MEDIA-TYPE')}
                <RadioButtons action={action} inputName="mediaType" options={options.mediaTypes} isRequired setField={(_, v) => setMediaType(v.value)} />
            </div>
            <div className="form-element">
                {t(label + 'LINK')}
                <TextInput action={action} inputName="link" variables={variables}
                    setOpenVariable={setOpenVariable} fieldType="string" displayName={t(label + 'LINK')} isRequired />
                <small><em>{t(label + (mediaType === 'image' ? 'IMAGE-TYPE-COMMENT' : 'VIDEO-TYPE-COMMENT'))}</em></small>
            </div>
            <div className="form-element">
                {t(label + 'CAPTION')}
                <TextInput action={action} inputName="caption" variables={variables}
                    setOpenVariable={setOpenVariable} multiline rows={4} fieldType="string" displayName={t(label + 'CAPTION')} />
            </div>
        </div>
    );
}

export default SendMedia;
